import { VehicleValuationStatus } from "@/api-schema-enums";

export const canVehicleValuationBeConfirmed = (status: VehicleValuationStatus): boolean => {
  return VehicleValuationStatus.InProgress === status;
};
